import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const MovieSelector = () => {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMovies();
  }, []);

  const fetchMovies = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/quiz/movies?limit=10');
      setMovies(response.data.data || []);
    } catch (error) {
      console.error('Error fetching movies:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMovieSelect = movieId => {
    navigate(`/quiz/${movieId}`);
  };

  return (
    <div style={{ minHeight: '100vh', padding: '2rem 0' }}>
      <div className='container'>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2rem' }}>
          <button
            onClick={() => navigate('/')}
            className='btn btn-secondary'
            style={{ marginRight: '1rem' }}
          >
            ← Back
          </button>
          <h1 style={{ fontSize: '2rem', color: 'white', margin: 0 }}>Select a Movie</h1>
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem 0' }}>
            <div className='loading-spinner'></div>
          </div>
        ) : (
          <div className='grid grid-2'>
            {movies.map(movie => (
              <div
                key={movie._id}
                className='card'
                style={{ cursor: 'pointer' }}
                onClick={() => handleMovieSelect(movie._id)}
              >
                <h3 style={{ fontSize: '1.25rem', color: 'white', marginBottom: '0.5rem' }}>
                  {movie.movieName}
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '1rem' }}>
                  {movie.year} • {movie.filmPrimaryLanguage}
                </p>

                {movie.starring && (
                  <div style={{ marginBottom: '1rem' }}>
                    <p
                      style={{
                        color: 'rgba(255,255,255,0.6)',
                        fontSize: '0.875rem',
                        marginBottom: '0.25rem',
                      }}
                    >
                      Starring:
                    </p>
                    <p style={{ color: 'white', fontSize: '0.875rem' }}>{movie.starring}</p>
                  </div>
                )}

                {movie.directedBy && (
                  <div style={{ marginBottom: '1rem' }}>
                    <p
                      style={{
                        color: 'rgba(255,255,255,0.6)',
                        fontSize: '0.875rem',
                        marginBottom: '0.25rem',
                      }}
                    >
                      Director:
                    </p>
                    <p style={{ color: 'white', fontSize: '0.875rem' }}>{movie.directedBy}</p>
                  </div>
                )}

                <button className='btn btn-primary' style={{ width: '100%' }}>
                  Generate Quiz
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MovieSelector;
